import type { ReactNode } from 'react'
import { WorkspaceNavigation } from 'src/design-system/ui'
import { App2CasesPanel } from 'src/components/App2Cases/App2CasesPanel'
export const CASE_LIST_HIDDEN_KEY = 'app2CaseListHidden'
export const App2CaseNavigation = ({
  children,
}: {
  children: (toggle: ReactNode) => ReactNode
}) => (
  <WorkspaceNavigation
    storageKey={CASE_LIST_HIDDEN_KEY}
    id="app2-case-list"
    renderPanel={(headerAction, afterNavigate) => (
      <App2CasesPanel
        compact
        headerAction={headerAction}
        onNavigate={afterNavigate}
      />
    )}
  >
    {children}
  </WorkspaceNavigation>
)
